// src/modules/app-views/fiscalConfig/pages/Document/tabs/NfceTab/VoidNfceCard.jsx
// *******************************************************************************
// VOID NFCE CARD - Card separado para inutilização de numeração NFC-e
// *******************************************************************************
import { Card, Row, Col, Button, Typography } from 'antd';
import { StopOutlined } from '@ant-design/icons';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const VoidNfceCard = ({ onOpenVoidNfceModal }) => {
    // ─────────────────────────────────────────────────────────────────────────────
    // UI
    // ─────────────────────────────────────────────────────────────────────────────
    return (
        <Card
            title={translateX('void_number_range')}
            style={{ marginTop: 16 }}
        >
            {/* Description */}
            <Row gutter={16}>
                <Col span={24}>
                    <Text type="secondary" style={{ fontSize: 13 }}>
                        {translateX('void_number_range_description')}
                    </Text>
                </Col>
            </Row>

            {/* Action button */}
            <Row gutter={16} style={{ marginTop: 16 }}>
                <Col span={24}>
                    <Button
                        type="primary"
                        icon={<StopOutlined />}
                        onClick={onOpenVoidNfceModal}
                    >
                        {translateX('void_numbers')}
                    </Button>
                </Col>
            </Row>
        </Card>
    );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default VoidNfceCard;
